import { SETTOGGLEIMAGES } from "../constants/action_types.js";

const image_handler = (displaying = false, action) =>
{
  switch (action.type)
  {
    case SETTOGGLEIMAGES:
      return !displaying;
    default:
      return displaying;
  }
}

export default image_handler;
